import request from '@/sheep/request';

// 获得地区树
export const getAreaTree = () => {
	return request({
		url: '/system/area/tree',
		method: 'GET'
	});
}